<div class="main-container" xmlns="http://www.w3.org/1999/html">
  <div class="ui grid">
    <div class="sixteen wide mobile twelve wide tablet ten wide computer column">
      <h1>
        <i class="help icon"></i> Help
      </h1>

      <!--<div class="ui fluid left icon input">
        <input type="text" placeholder="Search">
        <i class="search icon"></i>
      </div>-->

      <br><br>


      <!-- Quotes -->
      <h4 class="ui dividing header">
        Quotes
      </h4>

      <div class="ui styled fluid accordion">
        <div class="title">
          <i class="dropdown icon"></i>
          How do I create a quote?
        </div>
        <div class="content">
          <p class="transition hidden">
            To create a quote:<br>
            1. Navigate to the 'Quotes' page by clicking on Quotes in the top navigation bar.<br>
            2. Click 'New Quote'.<br>
            3a. If the quote is for a customer you have worked with in the past you can enter their name in the search field and select them.<br>
            3b. If this is a new customer just click “Start Quote” and you can add the customer name later.<br>
            4. Now your ready to start adding items to the quote.<br>
            5. When your done, hit the preview button at the bottom of the screen to bring up the quote preview screen.<br>
            6. In this view you can attach notes to tasks and ensure the quantities are correct.<br>
          </p>
        </div>
        <div class="title">
          <i class="dropdown icon"></i>
          How do I send a quote?
        </div>
        <div class="content">
          <p class="transition hidden">
            To send a quote:<br>
            1. When happy with the quote on the quote preview screen you can hit 'Send'.<br>
            2. This will bring up the compose email modal where you can type a message to be seen by your customer.<br>
            3. When your ready click 'Send' and the quote will be emailed to your customer.<br>
            4. (Optional) If you've integrated Xero you'll see the quote appear under the 'Drafts' section of Invoices.<br>
          </p>
        </div>
      </div>

      <!-- Contacts -->
      <h4 class="ui dividing header">
        Contacts
      </h4>

      <div class="ui styled fluid accordion">
        <div class="title">
          <i class="dropdown icon"></i>
          How do I add a contact?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a contact:<br>
            1. Navigate to the 'Contacts' page by clicking on 'Contacts' in the top navigation bar.<br>
            2. Click 'New Contact'.<br>
            3. Add in all known details and hit 'Save'.<br>
            4. (Optional) If you have integrated Xero you'll see the contact appears 'Contacts' within a few seconds (if you don't try refreshing the page).<br>
          </p>
        </div>
      </div>

      <!-- Settings -->
      <h4 class="ui dividing header">
        Settings
      </h4>

      <div class="ui styled fluid accordion">
        <div class="title">
          <i class="dropdown icon"></i>
          How do I add users?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a user:<br>
            1. Navigate to the 'Settings' page by clicking on 'Settings' in the top navigation bar.<br>
            2. Select 'Users' from the tab bar. (Note: If you don't see this option, its because you don't have
            sufficient access rights. Only users with full access can invite new users).<br>
            3. Click 'Invite User'.<br>
            4. Enter all required details and select the users level of access.<br><br>
            Full Access: <br>Can access all areas and do all the things.<br><br>
            Trusted Access: <br>Can create quotes/contacts, view display settings and add new materials/products/tasks.
            Can't view account/financial information, invite new users or add new integrations.<br><br>
            Restricted Access: <br>Can create quotes/contacts, view material/product/task settings.
            Can't view account/display settings or add/change materials/products/tasks).<br><br>
            5. Hit 'Invite' to email an invitation link to the new user.<br>
            6. Once that user accepts, creates their account and signs in they will be able to start using Smardie.<br>
          </p>
        </div>

        <div class="title">
          <i class="dropdown icon"></i>
          How do I add custom materials?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a custom material:<br>
            1. Navigate to the 'Settings' page by clicking on 'Settings' in the top navigation bar.<br>
            2. Select 'Material' from the side bar. (Note: Only 'Full' and 'Trusted' users can edit default or create custom materials).<br>
            3. Click 'Add New Material'.<br>
            4. Enter images and all required details:<br><br>
            Description:<br>This is the name of material and is what will appear in the list.<br><br>
            Material Type: <br>The classification type the material belongs to.<br><br>
            Material Size: <br>The diameter of the material (if this isn't required select 'n/a')<br><br>
            Unit of Measure: <br>Is the material measured by lineal metre or individually (Each)<br><br>
            Price: <br>The cost of the material. (Price listed is ex-GST)<br><br>
            Stocked Item: <br>Is this an item you would normally expect to keep in stock?<br><br>
            5. Hit 'Save' to finish adding the material. This material is now ready to be assigned to a task.<br>
            6. To edit this material you'll find it under the 'Custom' tab in 'Material Settings'.<br>

          </p>
        </div>

        <div class="title">
          <i class="dropdown icon"></i>
          How do I add custom products?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a custom product:<br>
            1. Navigate to the 'Settings' page by clicking on 'Settings' in the top navigation bar.<br>
            2. Select 'Product' from the side bar. (Note: Only 'Full' and 'Trusted' users can edit default or create custom products).<br>
            3. Click 'Add New Product'.<br>
            4. Enter images and all required details:<br><br>
            Description:<br>This is the name of product and is how the product will appear on quotes/invoices.<br><br>
            Product Type: <br>The classification type the product belongs to.<br><br>
            Product Brand: <br>The brand of the product.<br><br>
            Stocked Item: <br>Is this an item you would normally expect to keep in stock?<br><br>
            Main Supplier: <br>The primary stockist where you'd normally purchase this item (optional).<br><br>
            Supplier ID: <br>The product code of the item at the main supplier (optional).<br><br>
            Price: <br>The cost of the product. (Price listed is ex-GST)<br><br>
            5. Hit 'Next'<br>
            6. Select one or multiple 'Product Classification(s)'. This is where you'll find the product when creating a quote.<br>
            7. Hit 'Save' to finish adding the product. This product is now ready to be added to quotes or assigned to a task.<br>
            8. To edit this product you'll find it under the 'Custom' tab in 'Product Settings'.<br>
          </p>
        </div>

        <div class="title">
          <i class="dropdown icon"></i>
          How do I add a custom 'Time Based' task?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a task:<br>
            1. Navigate to the 'Settings' page by clicking on 'Settings' in the top navigation bar.<br>
            2. Select 'Task' from the sidebar. (Note: Only 'Full' and 'Trusted' users can edit default or create custom tasks).<br>
            3. Click 'Add New Task' and then select 'Time Based' task.<br>
            4. Enter images and all required details:<br><br>
            Description:<br>This is the name of the task and is how it will appear on quotes/invoices.<br><br>
            Hourly Labour Rate: <br>By default the rate shown here is you're standard hourly rate (as listed under 'Account Settings').
            However you can override the value for this particular task. Please note that if you change your standard hourly rate in 'Account Settings' the value for this task will not automatically change.<br><br>
            Time to Complete: <br>This is how long you would expect this task to take to be completed.
            The value listed here will be used in conjunction with your hourly labour rate to calculate the cost of the task.<br><br>
            5. Hit 'Next'<br>
            6. Select one or multiple 'Product Classification(s)'. This is where you'll find the task when creating a quote.<br>
            7. Select which Materials and Products are included within this task. This will ensure the true 'total cost' of the task is calculated.<br>
            8. Hit 'Save' to finish adding the task. This task is now ready to be added to quotes.<br>
            9. To edit this task you'll find it under the 'Custom' tab in 'Task Settings'.<br>
          </p>
        </div>

        <div class="title">
          <i class="dropdown icon"></i>
          How do I add a custom 'Calculated' task?
        </div>
        <div class="content">
          <p class="transition hidden">
            To add a task:<br>
            1. Navigate to the 'Settings' page by clicking on 'Settings' in the top navigation bar.<br>
            2. Select 'Task' from the sidebar. (Note: Only 'Full' and 'Trusted' users can edit default or create custom tasks).<br>
            3. Click 'Add New Task' and then select 'Calculated' task.<br>
            4. Select a template which will determine which formula will be used to calculate the total cost of the task.<br>
            5. Enter images and all required details:<br><br>
            Description:<br>This is the name of the task and is how it will appear on quotes/invoices.<br><br>
            Hourly Labour Rate: <br>By default the rate shown here is you're standard hourly rate (as listed under 'Account Settings').
            However you can override the value for this particular task. Please note that if you change your standard hourly rate in 'Account Settings' the value for this task will not automatically change.<br><br>
            Time to Complete: <br>This is how long you would expect this task to take to be completed.
            The value listed here will be used in conjunction with your hourly labour rate to calculate the cost of the task.<br><br>
            6. Hit 'Next'<br>
            7. Select which Materials and Products are included within this task. This will ensure the true 'total cost' of the task is calculated.<br>
            9. Hit 'Save' to finish adding the task. This task is now ready to be added to quotes.<br>
            10. To edit this task you'll find it under the 'Custom' tab in 'Task Settings'.<br>
          </p>
        </div>

        <div class="title">
          <i class="dropdown icon"></i>
          How do I integrate with Xero?
        </div>
        <div class="content">
          <p class="transition hidden">
            To integrate with Xero:<br>
            1. Navigate to the ‘Settings’ page by clicking on Settings in the top navigation bar.<br>
            2. Click Integrations.<br>
            3. Click 'Connect' to connect your Xero account.<br>
            4. When prompted enter your Xero login credentials and connect your account.<br>
            5. In Smardie, you can now add contacts and create quotes and see the details sync across to Xero within a few seconds.
          </p>
        </div>
      </div>

      <!-- Miscellaneous -->
      <h4 class="ui dividing header">
        Miscellaneous
      </h4>

      <div class="ui styled fluid accordion">
        <div class="title">
          <i class="dropdown icon"></i>
          How do I contact customer support?
        </div>
        <div class="content">
          <p class="transition hidden">
            Still haven't found what you're looking for? Contact our friendly customer support team at
            <a class="primary" href="mailto:support@smardie.com">support@smardie.com</a> and they'll get back to you as soon as possible.
          </p>
        </div>
      </div>

    </div>
  </div>
  <br><br>
</div>

